// extracted by mini-css-extract-plugin
module.exports = {"resi":"resi_resi__1JfHX","deliveryFlow":"resi_deliveryFlow__2zEv6"};